module.exports = __webpack_public_path__ + "static/img/ls.74398163.png";